<div class="visualization-tile">
  <div class="tile-header">
    <div class="tile-header-title">Assessment Status By Quarter</div>
  </div>
  <div class="tile-content">
    <div style="display:block; height: -webkit-fill-available;">
      <canvas #myCanvas baseChart
        [datasets]="barChartData"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [legend]="barChartLegend"
        [colors]="barChartColors"
        [chartType]="barChartType"></canvas>
    </div>
  </div>
</div>